export default __webpack_public_path__ + "static/media/virusLoader.ac4a3d7c.gif";